<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <h2 class="text-center mt-5 mb-5">{{ translations.changeOrder[lang] }}</h2>
        <v-card class="mx-auto mt-5 mb-5" max-width="800">
            <div class="mb-5 pt-5 text-right">
                <v-btn
                    class="mr-5"
                    color="secondary"
                    @click="updateOrders"
                    depressed
                    >{{ translations.update[lang] }}</v-btn
                >
            </div>
            <v-list class="pr-3 pl-3" max-width="70%">
                <v-list-item-group>
                    <draggable v-model="products">
                        <v-list-item
                            class="grey lighten-3 mb-1"
                            v-for="(item, i) in products"
                            :key="i"
                        >
                            <v-list-item-icon>
                                <v-icon
                                    v-text="icons.mdiSwapVerticalBold"
                                ></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title
                                    v-text="item.name[lang]"
                                ></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </draggable>
                    <div class="text-center mt-6">
                        <v-pagination
                            v-model="page"
                            :length="totalPagesLength"
                            :total-visible="5"
                            color="#2a3042"
                        ></v-pagination>
                    </div>
                </v-list-item-group>
            </v-list>
            <!-- <div class="mb-5 pb-5 text-right">
                <v-btn class="mr-5" color="primary" depressed>Update</v-btn>
            </div> -->
        </v-card>
    </v-tab-item>
</template>

<script>
import { mdiSwapVerticalBold } from "@mdi/js";
import draggable from "vuedraggable";
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/products/productsTab";

export default {
    name: "ProductsSeries",
        
    mixins: [translations],

    data() {
        return {
            icons: {
                mdiSwapVerticalBold,
            },
            page: +this.$route.query.page,
        };
    },

    components: {
        draggable,
    },

    computed: {
        ...mapState("loyaltyPanel/productSeries", ["totalPagesLength"]),

        lang() {
            return this.$route.params.lang;
        },

        products: {
            get() {
                return this.$store.state.loyaltyPanel.productSeries.products;
            },
            set(value) {
                this.updateList(value);
            },
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/productSeries", [
            "getItems",
            "updateSorting",
        ]),

        ...mapMutations("loyaltyPanel/productSeries", ["updateList"]),

        updateOrders() {
            this.updateSorting(this.products);
        },
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getItems(this.query);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },
    },

    mounted() {
        this.getItems(this.query);
    },
};
</script>
